import { gql } from '@apollo/client'

export const RemoveChatReaction = gql`
    mutation RemoveChatReaction($roomId: ID!, $reactionId: ID!) {
        removeChatReaction(roomId: $roomId, reactionId: $reactionId) {
            id
            room {
                id
            }
            updated
        }
    }
`

export default RemoveChatReaction

